import ky from "ky";
import type { APIShip } from "./shiptype";
const fetchDetail = async (id: string) =>
  ky(`https://formidable-6alfjpzcsq-uc.a.run.app/ships/id?code=${id}`, {
    headers: { "content-type": "application/json" },
  }).json<APIShip>();

export default fetchDetail;
